<template>
  <div class="app-layout">
    <v-navigation-drawer
      app
      clipped
      v-model="drawer"
    >
      <v-list>
        <v-list-tile :to="{ name: 'tracking' }">
          <v-list-tile-action>
            <v-icon>directions_car</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Seguimiento</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ name: 'geofences' }">
          <v-list-tile-action>
            <v-icon>layers</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Geocercas</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ name: 'routes' }">
          <v-list-tile-action>
            <v-icon>navigation</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Rutas</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ name: 'places' }">
          <v-list-tile-action>
            <v-icon>place</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Lugares</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ name: 'reports' }">
          <v-list-tile-action>
            <v-icon>track_changes</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Reportes</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ name: 'travels' }">
          <v-list-tile-action>
            <v-icon>directions</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Recorridos</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="!sessionIsGuest" :to="{ name: 'guests' }">
          <v-list-tile-action>
            <v-icon>person</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Invitados</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app clipped-left>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Rastreo Siglo XXI</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y bottom left>
        <v-btn icon slot="activator">
          <v-icon>notifications</v-icon>
        </v-btn>
        <v-toolbar>
          <v-toolbar-title>Notificaciones</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon>settings</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>Coming soon...</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu offset-y bottom left>
        <v-btn icon slot="activator">
          <v-icon>account_circle</v-icon>
        </v-btn>
        <v-card>
          <v-list>
            <v-list-tile :to="{ name: 'profile' }">
              <v-list-tile-action>
                <v-icon large>account_circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ sessionName }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list>
            <v-list-tile :to="{ name: 'profile' }">
              <v-list-tile-action>
                <v-icon>account_box</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Mi cuenta</v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ name: 'help' }">
              <v-list-tile-action>
                <v-icon>help</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Ayuda</v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>feedback</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Enviar feedback</v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="{ name: 'login' }">
              <v-list-tile-action>
                <v-icon>exit_to_app</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Cerrar sesión</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-content>
      <!-- <v-alert class="ma-0" color="error" icon="warning" value="true">Hay problemas en el funcionamiento de la plataforma</v-alert> -->
      <router-view/>
    </v-content>
  </div>
</template>

<script>

export default {
  name: 'layout',
  data: function () {
    return {
      sessionIsGuest: false,
      sessionName: '',
      drawer: true
    }
  },
  created: function () {
    // Fix boolean string
    this.sessionIsGuest = JSON.parse(localStorage.getItem('heimdall-session-is-guest'))
    this.sessionName = localStorage.getItem('heimdall-session-name')
  }
}
</script>

<style lang="sass" scoped>
#navigation-drawer-view
  height: calc(100vh - 64px)
  max-height: calc(100vh - 64px)
  overflow-x: hidden
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue